// I18n
export const defaultLocale = 'en';
export const defaultDateFormat = 'YYYY.MM.DD';
export const defaultDateTimeFormat = defaultDateFormat + '  HH:mm:ss';

// Auth
export const AuthTokenName = 'session_token.next-auth-admin';
export const AuthTokenExpire = 60 * 60 * 24; // 1 day
export const AuthTokenMaxAge = 1000 * AuthTokenExpire; // 1 day
